import React from 'react'

function PageTitle({title}) {
  return (
    <h1>{title}</h1>
  )
}

export default PageTitle